import { useMemo } from 'react';

import {
  createLeadInPriceSorter,
  RoomWithMatchingLeadInOffer,
  RoomWithMatchingOffer,
  sortByOfferPrice,
} from '../../utils/roomOptions';

export type BaseRoomOption = RoomWithMatchingLeadInOffer &
  RoomWithMatchingOffer;

export type UseSortedMainRoomOptionsProps<T extends BaseRoomOption> = {
  roomOptions: T[] | null | undefined;
  isOriginAndPackageSelected: boolean | undefined;
  isPreSearch: boolean | undefined;
  route: string | undefined;
};

const useSortedMainRoomOptions = <T extends BaseRoomOption>({
  roomOptions,
  isPreSearch,
  isOriginAndPackageSelected,
  route,
}: UseSortedMainRoomOptionsProps<T>) => {
  return useMemo(() => {
    if (!roomOptions || !isOriginAndPackageSelected) {
      return roomOptions;
    }

    if (isPreSearch) {
      if (!route) {
        return roomOptions;
      }

      const sortByLeadInPrice = createLeadInPriceSorter(route);
      return [...roomOptions].sort(sortByLeadInPrice);
    }

    return [...roomOptions].sort(sortByOfferPrice);
  }, [isOriginAndPackageSelected, isPreSearch, roomOptions, route]);
};

export default useSortedMainRoomOptions;
